export const SectionHeroTranslationsCs = {
  'Platform Description':
    'platforma pro pronájem luxusního oblečení a zboží pro děti a rodiny',
  rent: 'pronajmout si',
};
